import { CryptographyRandom7x2mkp21hkpe as CryptographyRandom } from './CryptographyRandom.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AbstractRandomClass;
function AbstractRandom() {
  if (AbstractRandomClass === VOID) {
    class $ extends CryptographyRandom() {
      static new_dev_whyoleg_cryptography_random_AbstractRandom_15v2cv_k$() {
        return this.new_dev_whyoleg_cryptography_random_CryptographyRandom_41b3eh_k$();
      }
      nextBits_kty4bl_k$(bitCount) {
        var numBytes = (bitCount + 7 | 0) / 8 | 0;
        var b = this.nextBytes_dtk0kg_k$(numBytes);
        var next = 0;
        var inductionVariable = 0;
        if (inductionVariable < numBytes)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            next = (next << 8) + (b[i] & 255) | 0;
          }
           while (inductionVariable < numBytes);
        return next >>> (imul(numBytes, 8) - bitCount | 0) | 0;
      }
      nextBytes_ln07bs_k$(array) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        // Inline function 'kotlin.collections.isEmpty' call
        if (!(array.length === 0)) {
          this.fillBytes_4b4b08_k$(array);
        }
        return array;
      }
    }
    initMetadataForClass($, 'AbstractRandom');
    AbstractRandomClass = $;
  }
  return AbstractRandomClass;
}
//region block: exports
export {
  AbstractRandom as AbstractRandom2p16g6waffir7,
};
//endregion

//# sourceMappingURL=AbstractRandom.mjs.map
